import React, { useState, useEffect } from 'react';
import '../../styles/ReportProblemPage.scss';
import translations from '../../translate';
import backIcon from '../../img/Back.svg';
import { useTheme } from '../../ThemeContext';
import { useNavigate } from 'react-router-dom';

const ReportProblemPage = () => {
  const [problem, setProblem] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [fadeOut, setFadeOut] = useState(false);
  const [userInfo, setUserInfo] = useState({
    user_id: '',
    telegram_user_id: '',
    first_name: ''
  });

  const { theme } = useTheme();
  const navigate = useNavigate();
  const language = localStorage.getItem('language') || 'lv';
  const text = translations[language];

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('userSession'));
    if (storedUser) {
      setUserInfo({
        user_id: storedUser.id,
        telegram_user_id: storedUser.telegram_user_id,
        first_name: storedUser.first_name
      });
    }
  }, []);

  useEffect(() => {
    if (error) {
      setFadeOut(false);
      const fadeTimer = setTimeout(() => setFadeOut(true), 3500);
      const clearTimer = setTimeout(() => setError(''), 4000);

      return () => {
        clearTimeout(fadeTimer);
        clearTimeout(clearTimer);
      };
    }
  }, [error]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const payload = {
      ...userInfo,
      problem_description: problem
    };

    try {
      const res = await fetch('/api/report-problem', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'language': language
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || text.submitError);
      }

      setSuccess(true);
    } catch (err) {
      console.error(err);
      setError(err.message || text.submitError);
    }
  };

  return (
    <div className="report-problem-container" data-theme={theme}>
      <div className="title-container">
        <img
          src={backIcon}
          alt={text.back}
          className="back-icon"
          onClick={() => navigate('/main')}
        />
        <h2 className="title">{text.report}</h2>
      </div>

      <div className="report-box">
        {success ? (
          <div className="success-message">
            <h2>{text.thankYouReport}</h2>
            <p>{text.reportSuccessMessage}</p>
            <button onClick={() => navigate('/main')}>{text.close}</button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <p className="instruction">{text.reportIntro}</p>
            <textarea
              placeholder={text.describeProblem}
              value={problem}
              onChange={(e) => setProblem(e.target.value)}
            />

            {error && (
              <div className="custom-alert-wrapper">
                <div className={`alert alert-danger ${fadeOut ? 'fade-out' : ''}`}>
                  {error}
                </div>
              </div>
            )}

            <button type="submit" className="submit-button">
              {text.sendReport}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ReportProblemPage;
